import config from '../../../config'

export const fetchImsData = imageId => {
  const { images_api_url: apiUrl, images_api_app_id: appId, images_api_app_key: appKey } = config

  // Create url to fetch image data from images-api-v2.
  const imsDataUrl = `${apiUrl}presentation_data/${imageId}.json?app_id=${appId}&app_key=${appKey}`

  return fetch(imsDataUrl).then(response => {
    if (response.ok && response.headers.get('content-type').includes('application/json')) {
      return response.json()
    }

    // Fetch failed, reset state to not show the previous image.
    throw new Error(`Failed fetching IMS image with id ${imageId}`)
  })
}

const getCropCoordinates = ({ aspect, imsData }) => {
  if (!aspect) {
    return ''
  }

  // Make sure the image has crops for the selected aspect ratio.
  const crop = imsData.crops.find(data => data.name === aspect)
  if (!crop) {
    return ''
  }

  const { height, width, x, y } = crop.coordinates
  return `crop_extract,w_${width},h_${height},x_${x},y_${y}/`
}

const getDpr = () => {
  try {
    if (window.devicePixelRatio > 1) {
      return 'dpr_2'
    }
    return 'dpr_1'
  } catch (_) {
    return 'dpr_1'
  }
}

export const createImsImageUrl = ({ aspect, imsData }) => {
  const { images_cdn_url: baseUrl } = config
  const { public_id: publicId, version } = imsData
  const crop = getCropCoordinates({ aspect, imsData })
  const dpr = getDpr()
  const parameters = `crop_fill,w_600,q_80,${dpr}`

  return `${baseUrl}/${crop}${parameters}/${publicId}/${version}`
}
